// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    deleteAssetError: {
        id: "apps.remoteAssets.hooks.deleteAssetError",
        description: "Delete asset error.",
        defaultMessage: "Could not delete the remote asset.",
    },
    bulkDeletePartialError: {
        id: "apps.remoteAssets.hooks.bulkDeletePartialError",
        description: "Bulk delete partial error.",
        defaultMessage: "{successCount} assets deleted, {failedCount} failed.",
    },
    bulkDeleteError: {
        id: "apps.remoteAssets.hooks.bulkDeleteError",
        description: "Bulk delete error.",
        defaultMessage: "Could not delete the remote assets.",
    },
    updateAssetError: {
        id: "apps.remoteAssets.hooks.updateAssetError",
        description: "Update asset error.",
        defaultMessage: "Could not update the remote asset.",
    },
    bulkUpdateForkingPartialError: {
        id: "apps.remoteAssets.hooks.bulkUpdateForkingPartialError",
        description: "Bulk update forking partial error.",
        defaultMessage: "{failedCount} asset(s) could not be updated.",
    },
    bulkUpdateForkingError: {
        id: "apps.remoteAssets.hooks.bulkUpdateForkingError",
        description: "Bulk update forking error.",
        defaultMessage: "Could not update copying settings.",
    },
    noOrganizationSelectedError: {
        id: "apps.remoteAssets.hooks.noOrganizationSelectedError",
        description: "No organization selected error.",
        defaultMessage: "No organization selected.",
    },
    searchAssetsPlaceholder: {
        id: "apps.remoteAssets.hooks.searchAssetsPlaceholder",
        description: "Search assets placeholder.",
        defaultMessage: "Search assets...",
    },
    errorBadUserInput: {
        id: "apps.remoteAssets.hooks.errorBadUserInput",
        description: "Error bad user input.",
        defaultMessage: "Invalid input. Please check your data and try again.",
    },
    errorUnauthenticated: {
        id: "apps.remoteAssets.hooks.errorUnauthenticated",
        description: "Error unauthenticated.",
        defaultMessage: "You are not logged in. Please sign in and try again.",
    },
    errorForbidden: {
        id: "apps.remoteAssets.hooks.errorForbidden",
        description: "Error forbidden.",
        defaultMessage: "You don't have permission to perform this action.",
    },
    errorNotFound: {
        id: "apps.remoteAssets.hooks.errorNotFound",
        description: "Error not found.",
        defaultMessage: "This asset could not be found. It may have been deleted.",
    },
    errorRateLimited: {
        id: "apps.remoteAssets.hooks.errorRateLimited",
        description: "Error rate limited.",
        defaultMessage: "Too many requests. Please wait a moment and try again.",
    },
    errorGeneric: {
        id: "apps.remoteAssets.hooks.errorGeneric",
        description: "Error generic.",
        defaultMessage: "Something went wrong. Please try again later.",
    },
});
